// MARK: React
import * as React from "react";

// MARK: Mobx
import { observer, inject } from "mobx-react";

// MARK: Components
import DashboardLayout from "../../../../layouts/DashboardLayout";
import PageTable from "../../../../components/PageTable";

// MARK: Stores
import CommentStore from "../../../../stores/CommentStore";

// MARK: Resources
import strings from "../../../../resources/strings";

interface IProps {
	commentStore: CommentStore;
}

@inject("commentStore")
@observer
export default class CommentTable extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.commentStore.getComments(0);
	};

	public render() {
		const {commentStore} = this.props;
		return (
			<DashboardLayout>
				<PageTable
					tableConfig={{
						title: strings.comment.title,
						rows: commentStore.commentTableRows,
						header: commentStore.header,
						pageOffset: commentStore.commentPageOffset,
						loading: commentStore.loading,
						prevPage: commentStore.previousPage,
						nextPage: commentStore.nextPage,
						onDeleteClick: commentStore.openDeleteCommentDialog,
						onDetailClick: commentStore.redirectToCommentDetails,
					}}
				/>
			</DashboardLayout>
		);
	}
}
